import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-590326ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Softwarematig onderhoud", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " De oorzaak van een langzaam werkende computer is in veel gevallen de aanwezigheid van onnodige software. Bij onnodige software kunt u denken aan virussen, reclame en ongebruikte programma's. Vaak wordt dit soort software ongemerkt automatisch met de computer opgestart. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " MaatComputers herkent en verwijdert onnodige software, waardoor de computer wordt ontlast. Het resultaat is een computer die minder tijd nodig heeft om op te starten en in staat is om taken sneller uit te voeren. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Hardwarematig onderhoud", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Stoffige koelelementen en opgedroogde koelpasta kunnen de oorzaak zijn van een langzaam werkende computer. De chips van een computer zijn gemaakt om op een bepaalde temperatuur te werken. Indien deze chips te warm worden, werken ze niet optimaal. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Het schoonmaken van koelelementen en het vervangen van koelpasta kan ervoor zorgen dat de computer niet te warm wordt. Een goed gekoelde computer werkt sneller en slijt minder snel. MaatComputers controleert de staat van uw hardware en voert waar nodig onderhoud uit. ", -1))
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Onderhoud",
      displaySearchForm: false
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createElementVNode("img", { src: $data.onderhoudImage }, null, 8, _hoisted_8)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout)
  ], 64))
}